import React, { Suspense, lazy, useState, useEffect } from "react";
import "./index.css";
//import loader from "./asset/wib.png";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import { PrivateRoutes } from "./routing/PrivateRoutes";
import OfflineNotice from "./components/OfflineNotice";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import ProductDetails from "./components/ProductDetails";
import { useNetworkState } from "react-use";
import { DataProvider } from "./DataContext/DataContext";

const Home = lazy(() => import("./components/Home"));
const MyAccount = lazy(() => import("./components/MyAccount"));
const Wishlist = lazy(() => import("./components/Wishlist"));
const Cart = lazy(() => import("./components/Cart"));
const OTC = lazy(() => import("./components/OTC"));
const Checkout = lazy(() => import("./components/Checkout"));
const Register = lazy(() => import("./components/Signup"));
const About = lazy(() => import("./components/About"));
const Medicines = lazy(() => import("./components/Medicines"));
const Vitamins = lazy(() => import("./components/Vitamins"));
const MotherBaby = lazy(() => import("./components/MotherBaby"));
const NewIn = lazy(() => import("./components/NewIn"));
const Shop = lazy(() => import("./components/Shop"));
const ProductAll = lazy(() => import("./components/ProductAll"));
const PrivacyAndPolicy = lazy(() => import("./components/PrivacyAndPolicy"));
const Faq = lazy(() => import("./components/Faq"));
const Category = lazy(() => import("./components/Category"));
const Filter = lazy(() => import("./components/Filter"));
const Search = lazy(() => import("./components/Search"));
const Navmobile = lazy(() => import("./components/Navmobile"));
const SuccessPayment = lazy(() => import("./components/SuccessPayment"));
const Order = lazy(() => import("./components/Order"));
const Profile = lazy(() => import("./components/Profile"));
const DirectContact = lazy(() => import("./components/DirectContact"));
const SpecialOffer = lazy(() => import("./components/SpecialOffer"));
const Hmain3 = lazy(() => import("./components/Headercomp/Hmain3"));
const CareSuggestions = lazy(() => import("./components/CareSuggestions"));
const HealthAdviceDetails = lazy(() => import("./components/HealthAdviceDetails"));
const Pop = lazy(() => import("./components/popads"));

const NavigationWrapper = ({ children, online }) => {
  const location = useLocation();
  const hideLayout = ["/login", "/register", "/forgot-password", "/care-suggestions"].includes(location.pathname) || location.pathname.startsWith("/health-advice");

  return (
    <>
      <Suspense fallback={null}>
        <Pop />
      </Suspense>
      {!online && <OfflineNotice />}
      {!hideLayout && <Header />}
      <Suspense fallback={null}>
        {children}
        {!hideLayout && <DirectContact />}
        {!hideLayout && <Hmain3 />}
      </Suspense>
    </>
  );
};

function App() {
  const { online } = useNetworkState();
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 5000); // Display the loader for 5 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <BrowserRouter>
      <DataProvider>
        <NavigationWrapper online={online}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/myaccount" element={<MyAccount />} />
            <Route
              path="/wishlist"
              element={
                <PrivateRoutes>
                  <Wishlist />
                </PrivateRoutes>
              }
            />
            <Route
              path="/cart"
              element={
                <PrivateRoutes>
                  <Cart />
                </PrivateRoutes>
              }
            />
            <Route path="/otc" element={<OTC />} />
            <Route
              path="/checkout"
              element={
                <PrivateRoutes>
                  <Checkout />
                </PrivateRoutes>
              }
            />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/login" element={<Login />} />
            <Route path="/productdetails/:id" element={<ProductDetails />} />
            <Route path="/register" element={<Register />} />
            <Route path="/about" element={<About />} />
            <Route path="/user/profile" element={<Profile />} />
            <Route path="/header" element={<Header />} />
            <Route path="/medicines" element={<Medicines />} />
            <Route path="/otc" element={<OTC />} />
            <Route path="/vitamins" element={<Vitamins />} />
            <Route path="/mother-baby" element={<MotherBaby />} />
            <Route path="/new" element={<NewIn />} />
            <Route path="/shop/:id" element={<Shop />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/special-offer" element={<SpecialOffer />} />
            <Route path="/productall" element={<ProductAll />} />
            <Route path="/privacyandpolicy" element={<PrivacyAndPolicy />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/category" element={<Category />} />
            <Route path="/filter" element={<Filter />} />
            <Route path="/search" element={<Search />} />
            <Route path="/navmobile" element={<Navmobile />} />
            <Route path="/orders" element={<Order />} />
            <Route path="/payment/success" element={<SuccessPayment />} />
            <Route path="/care-suggestions" element={<CareSuggestions />} />
            <Route path="/health-advice" element={<CareSuggestions />} />
            <Route path="/health-advice/:id" element={<HealthAdviceDetails />} />
          </Routes>
        </NavigationWrapper>
      </DataProvider>
    </BrowserRouter>
  );
}

export default App;
